import styled from '@emotion/styled'
import { motion } from 'framer-motion'

interface IProps {
  level: number
  className?: any
}

export default function Index({ level, className }: IProps) {
  const levelStatus = (num: number) => {
    let el = null
    switch (num) {
      case 1:
        el = (
          <>
            <span className="w-[0.4vh] h-[1vh] bg-[#FF402B] rounded-[0.3vh]"></span>
            <span className="w-[0.4vh] h-[1.6vh] bg-[#FFF] rounded-[0.3vh] mx-[0.4vh]"></span>
            <span className="w-[0.4vh] h-[2.1vh] bg-[#FFF] rounded-[0.3vh]"></span>
          </>
        )
        break
      case 2:
        el = (
          <>
            <span className="w-[0.4vh] h-[1vh] bg-[#FFA433] rounded-[0.3vh]"></span>
            <span className="w-[0.4vh] h-[1.6vh] bg-[#FFA433] rounded-[0.3vh] mx-[0.4vh]"></span>
            <span className="w-[0.4vh] h-[2.1vh] bg-[#FFF] rounded-[0.3vh]"></span>
          </>
        )
        break
      case 3:
        el = (
          <>
            <span className="w-[0.4vh] h-[1vh] bg-[#92FF33] rounded-[0.3vh]"></span>
            <span className="w-[0.4vh] h-[1.6vh] bg-[#92FF33] rounded-[0.3vh] mx-[0.4vh]"></span>
            <span className="w-[0.4vh] h-[2.1vh] bg-[#92FF33] rounded-[0.3vh]"></span>
          </>
        )
        break
      default:
        el = (
          <>
            <span className="w-[0.4vh] h-[1vh] bg-[#FFF] rounded-[0.3vh]"></span>
            <span className="w-[0.4vh] h-[1.6vh] bg-[#FFF] rounded-[0.3vh] mx-[0.4vh]"></span>
            <span className="w-[0.4vh] h-[2.1vh] bg-[#FFF] rounded-[0.3vh]"></span>
          </>
        )
        break
    }
    return el
  }

  return <Container className={`flex items-end ${className}`}>{levelStatus(level)}</Container>
}

const Container = styled(motion.div)``
